import { Component, OnInit } from '@angular/core';
import { AuditTrailComponent } from 'app/Shared/Component/audit-trail/audit-trail.componenet';
@Component({
    selector: 'app-audit-trail-details',
    imports: [AuditTrailComponent],
    template: `
  <div class="col-md-12 nopadding">
  <app-audit-trail 
      [SelectedRow]="selectedRow"
      [showFilter]="true"
      [staticFilter]="false"
      >
  </app-audit-trail>
</div>
`
})
export class AuditTrailDetailsComponent implements OnInit {

  selectedRow: any[] = [];

  constructor() { }

  ngOnInit() {
  }

}
